import React from 'react';
import styles from './IconButton.module.css';

function IconButton({ 
  icon, 
  onClick, 
  size = 'medium', 
  state = 'enabled'
}) {
  return (
    <button
      className={`${styles.iconButton} ${styles[size]} ${styles[state]}`}
      onClick={onClick}
      disabled={state === 'disabled'}
    >
      <svg 
        width="24" 
        height="24" 
        viewBox="0 0 24 24" 
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d={icon} />
      </svg>
    </button>
  );
}

export default IconButton;
